import cloneDeep from 'lodash/cloneDeep'
import {
  addLoadBoard as addLoadBoardApi,
  getLoadBoard as getLoadBoardApi,
  deactivateLoadBoard as deactivateLoadBoardApi
} from '@/api/load-boards'

export const loadBoards = [
  {
    name: 'Truckloads',
    logo: require('@/assets/img/load-boards/truckerpath.svg'),
    loadBoardsType: 1,
    status: 'connected' // connected、coming_soon
  },
  {
    name: 'Loadsmart',
    logo: require('@/assets/img/load-boards/load-smart.svg'),
    loadBoardsType: 2,
    status: 'coming_soon',
    text: 'Coming Soon'
  }
]

const store = {
  namespaced: true,
  state: {
    loadBoardList: cloneDeep(loadBoards),
    loadBoardTotal: 0,
    loadBoardCurrentPage: 1
  },
  mutations: {
    SET_LOAD_BOARD_LIST(state, list) {
      state.loadBoardList = list
    },
    SET_LOAD_BOARD_TOTAL(state, total) {
      state.loadBoardTotal = total
    },
    SET_LOAD_BOARD_CURRENT_PAGE(state, page) {
      state.loadBoardCurrentPage = page
    }
  },
  actions: {
    getLoadBoard({ commit }, params) {
      return getLoadBoardApi(params).then(res => {
        let list = cloneDeep(loadBoards)
        if (res.data.data) {
          list = list.map(item => {
            let info = res.data.data.find(i => i.loadBoardsType === item.loadBoardsType)
            if (info) {
              return Object.assign({}, item, info)
            } else {
              return item
            }
          })
        }
        commit('SET_LOAD_BOARD_LIST', list)
        commit('SET_LOAD_BOARD_TOTAL', res.data.total)
        commit('SET_LOAD_BOARD_CURRENT_PAGE', res.data.page)
        return res
      })
    },
    addLoadBoard({ commit, state }, data) {
      return addLoadBoardApi(data).then(res => {
        let list = state.loadBoardList.map(item => {
          if (item.loadBoardsType === data.loadBoardsType) {
            return Object.assign({}, item, res.data)
          }
          return item
        })
        commit('SET_LOAD_BOARD_LIST', list)
        return res
      })
    },
    deactivateLoadBoard({ commit, state }, info) {
      return deactivateLoadBoardApi({ ids: [info.id] }).then(res => {
        let list = cloneDeep(loadBoards).map(item => {
          if (item.loadBoardsType === info.loadBoardsType) {
            return item
          }
          return state.loadBoardList.find(i => i.loadBoardsType === item.loadBoardsType) || item
        })
        commit('SET_LOAD_BOARD_LIST', list)
        return res
      })
    }
  }
}

export default store